import { SxProps, Theme } from '@mui/material';

export const OrderHistoryTrackOrderFrameSX: SxProps<Theme> = {
	border: '1px solid #E8E8E8',
	backgroundColor: '#FFFFFF',
	borderRadius: 1,
};

export const OrderHistoryTrackOrderLabelSX: SxProps<Theme> = (theme) => ({
	fontSize: 'var(--font-size-small)',
	color: '#929292',
	marginBottom: theme.spacing(1),
});

export const OrderHistoryTrackOrderCopyButtonSX = (
	theme: Theme,
	guide?: string
): SxProps<Theme> => ({
	fontSize: 'var(--font-size-body)',
	fontWeight: 600,
	display: 'flex',
	gap: theme.spacing(0.5),
	color: guide ? theme.palette.primary.main : '#2c2c2c',
});

export const OrderHistoryTrackOrderDateSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-body)',
	fontWeight: 600,
};

export const OrderHistoryTrackOrderDHLButtonSX: SxProps<Theme> = (theme) => ({
	fontSize: 'var(--font-size-body)',
	color: theme.palette.primary.main,
	fontWeight: 600,
	display: 'flex',
	gap: theme.spacing(0.5),
	'&:hover': {
		textDecoration: 'underline',
	},
});
